import { render, staticRenderFns } from "./pick-up-code.scene.vue?vue&type=template&id=317b787f"
import script from "./pick-up-code.scene.ts?vue&type=script&lang=ts&external"
export * from "./pick-up-code.scene.ts?vue&type=script&lang=ts&external"
import style0 from "./pick-up-code.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports